<ng-container *ngIf="accessTokenInfo">
  <wm-libs-header [app]="'wm-tech-pool'" [env]="env" [accessToken]="true" [balance]="accessTokenBalance" [accessTokenPermissions]="accessTokenInfo.permissions"></wm-libs-header>

  <mat-sidenav-container [ngClass]="{ isMobile: isMobile$ | async }">
    <mat-sidenav mode="side" opened="true" disableClose="true" class="sidenav">
      <div class="sidebar-pool">
        <mat-nav-list [ngClass]="{ isMobile: (isMobile$ | async) }">
          <a mat-list-item class="item-select" (click)="centerItem('farm')">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 4.35418C12.7329 3.52375 13.8053 3 15 3C17.2091 3 19 4.79086 19 7C19 9.20914 17.2091 11 15 11C13.8053 11 12.7329 10.4762 12 9.64582M15 21H3V20C3 16.6863 5.68629 14 9 14C12.3137 14 15 16.6863 15 20V21ZM15 21H21V20C21 16.6863 18.3137 14 15 14C13.9071 14 12.8825 14.2922 12 14.8027M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z"
                stroke="#848484"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            {{ accessTokenInfo.name }}
          </a>
          <a *ngIf="accessTokenInfo.permissions.includes('statistics')" mat-list-item [ngClass]="{ active: activeTab === 'statistics' }" (click)="centerItem('statistics')">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8 13V12M12 13V10M16 13V8M8 21L12 17L16 21M3 4H21M4 4H20V16C20 16.5523 19.5523 17 19 17H5C4.44772 17 4 16.5523 4 16V4Z"
                stroke="#848484"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            {{ 'WM_TECH_POOL.D.MENU.STATISTICS' | translate }}
          </a>
          <a *ngIf="accessTokenInfo.permissions.includes('workers')" mat-list-item [ngClass]="{ active: activeTab === 'workers' }" (click)="centerItem('workers')">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 7V5" stroke="#848484" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
              <path d="M15 7V5" stroke="#848484" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
              <path d="M9 11H6" stroke="#848484" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
              <path d="M19 11H15" stroke="#848484" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
              <path
                d="M19.4104 10.6137C19.4082 8.59517 18.6769 6.65995 17.3769 5.23261C16.0768 3.80526 14.3142 3.00235 12.4757 3C10.6372 3.00235 8.87454 3.80526 7.57451 5.23261C6.27447 6.65995 5.54317 8.59517 5.54103 10.6137C5.31644 10.6126 5.09436 10.6656 4.89048 10.769C4.6866 10.8725 4.5059 11.0238 4.36114 11.2123C4.21638 11.4008 4.11109 11.622 4.05272 11.8601C3.99434 12.0982 3.98431 12.3475 4.02332 12.5903C4.10045 12.9951 4.30407 13.3576 4.59892 13.6149C4.89378 13.8723 5.26131 14.0084 5.63791 13.9996H19.3619C19.7385 14.0084 20.106 13.8723 20.4009 13.6149C20.6958 13.3576 20.8994 12.9951 20.9765 12.5903C21.0164 12.343 21.0054 12.089 20.9443 11.8469C20.8832 11.6049 20.7735 11.3809 20.6234 11.1914C20.4732 11.0019 20.2863 10.8516 20.0765 10.7517C19.8666 10.6517 19.639 10.6046 19.4104 10.6137Z"
                stroke="#848484"
                stroke-width="2"
                stroke-miterlimit="10"
              />
              <path
                d="M6 14.0405H19V14.8507C18.9888 16.4853 18.299 18.0493 17.0812 19.2014C15.8634 20.3535 14.2166 21 12.5 21C10.7761 21 9.12279 20.3479 7.90381 19.187C6.68482 18.0262 6 16.4518 6 14.8102V14V14.0405Z"
                stroke="#848484"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
            </svg>

            {{ 'WM_TECH_POOL.D.MENU.WORKERS' | translate }}
          </a>
          <a *ngIf="accessTokenInfo.permissions.includes('incomes')" mat-list-item [ngClass]="{ active: activeTab === 'incomes' }" (click)="centerItem('incomes')">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 7H21M21 7V15M21 7L13 15L9 11L3 17" stroke="#848484" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            {{ 'WM_TECH_POOL.D.MENU.REWARDS' | translate }}
          </a>
        </mat-nav-list>

        <div *ngIf="(isMobile$ | async) === true && accessTokenBalance" class="balance-mobile">
          <wm-libs-balance-block [balance]="accessTokenBalance"></wm-libs-balance-block>
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="main-content-wrapper">
        <app-statistics *ngIf="activeTab === 'statistics'" [withAccessTokenWorkers]="accessTokenInfo.permissions.includes('workers')"></app-statistics>
        <app-workers *ngIf="activeTab === 'workers'"></app-workers>
        <app-rewards *ngIf="activeTab === 'incomes'"></app-rewards>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <wm-libs-footer [accessToken]="true"></wm-libs-footer>
</ng-container>
